<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>销售管理</el-breadcrumb-item>
      <el-breadcrumb-item>历史散客消费单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-date-picker
      v-model="customerRequest.selectDate"
      type="daterange"
      range-separator="至"
      size="mini"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      @change="selectKpiData"
      value-format="yyyy-MM-dd"
      style="margin-left: 5px;"
    >
    </el-date-picker>
    <el-input size="mini" placeholder="请输入订单编号进行搜索"
              v-model="customerRequest.orderCode"
              style="width: 200px"></el-input>
    <el-button size="mini"  style="margin-left: 5px;" @click="queryOldOrder">查询</el-button>
    <el-table height="570px" :data="oldOrderList" fit border stripe="stripe"
              :header-cell-style="{background:'#eff3f8', color:'#333', fontWeight:700}"
              :row-style="{height: '0'}"
              show-summary>
      <el-table-column
        align="center"
        prop="orderDate"
        label="订单日期" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="orderCode"
        label="订单编号" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="paidAmount"
        label="消费金额" >
      </el-table-column>
      <el-table-column
        align="center"
        prop="id"
        label="消费单ID">
      </el-table-column>
    </el-table>
    <div style="margin-top: 3px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal">
      </el-pagination>
    </div>
  </div>

</template>

<script>
export default {
  data(){
    return{
      currentOrgId:'',
      oldOrderList:[],
      customerRequest:{
        pageNum:'',
        pageSize:'',
        orgId:'',
        selectDate:'',
        startDate:'',
        endDate:'',
        orderCode:''
      },
      currentPage:1,
      pageSize:20,
      pageTotal:0,
    }
  },
  methods:{
    selectKpiData(){
      if (this.customerRequest.selectDate === null){
        this.customerRequest.startDate = '';
        this.customerRequest.endDate = '';
      } else {
        this.customerRequest.startDate = this.customerRequest.selectDate[0];
        this.customerRequest.endDate = this.customerRequest.selectDate[1];
      }
    },
    queryOldOrder(){
      this.oldOrderCount();
      this.loadOldOrderList();
    },
    async oldOrderCount(){
      this.customerRequest.orgId = this.currentOrgId;
      const {data:res} = await this.$http.post(`/old/sk/order/count`,this.customerRequest);
      if (res.code === 200){
        this.pageTotal = res.totalPage;
      }
    },
    async loadOldOrderList(){
      this.customerRequest.orgId = this.currentOrgId;
      this.customerRequest.pageNum = this.currentPage;
      this.customerRequest.pageSize = this.pageSize;
      const {data:res} = await this.$http.post(`/old/sk/order/list`,this.customerRequest);
      if (res.code === 200){
        this.oldOrderList = res.data;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadOldOrderList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadOldOrderList();
    },
    getCurrentMonthFirst () {
      let date = new Date()
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      let day = date.getDate()
      if (month < 10) month = '0' + month
      if (day < 10) day = '0' + day
      return date.getFullYear() + '-' + month + '-' + day
    },
    getCurrentMonthLast () {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      month = month < 10 ? '0' + month : month
      let day = new Date(year, month, 0)
      return year + '-' + month + '-' + day.getDate()
    },
  },
  created() {
    this.currentOrgId = window.sessionStorage.getItem('currentOrgId');
  }
}
</script>


<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 92vh;
  background-color: #eff3f8;
}
.left_con{
  display: flex;
  justify-content: start;
  height: 100%;
  overflow-y: auto;
  //flex: 1;
  width: auto;
  //border: 1px solid;
  margin: 10px 0;
  //width: 100px;
}
.table_container{
  flex: 1;
  width: 800px;
  height: 100%;
}
.left_inner_con{
  width: 300px;
  height: 98%;
  overflow-y: auto;
  background-color: #F2F6FC;
}
.el-table, .el-table__cell {
  /deep/ th {
    padding: 2px ;
  }
  /deep/ td {
    padding: 2px ;
  }
}
.box-card{
  margin: 10px 10px 10px 10px;
  height: 87%;
}
/deep/ .el-dialog{
  background: #fafaff !important;
}

/deep/ .el-dialog__header{
  padding: 15px 20px 10px;
}

/deep/ .el-dialog__body{
  padding: 5px 25px;
  color:#606266;
  font-size:14px;
  word-break:break-all;
}

/deep/ .el-drawer__header{
  z-index: 1;
  position: relative;
  margin-bottom:0;
  color: #333 !important;
  .el-dialog__title{
    color: #333;
  }
  .el-dialog__close{
    color: #333 !important;
  }
}
.dialog-footer{
  display: flex;
  margin: 10px 10px 10px 0;
  justify-content: center;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/OldOrders.vue